<template>
    <div class="dual-navigation">
        <Cta
            v-if="layout.leftlink.id"
            :link="layout.leftlink"
        />
        <Cta
            v-if="layout.leftlink.id"
            :link="layout.rightlink"
        />
    </div>
</template>
<script>
import Cta from '@/components/layout/DualNavigation/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.dual-navigation
    margin-top: 10%
    margin-bottom: 10%
    display: flex
    @include media-breakpoint-down($lg)
        flex-direction: column
    @media print
        display: none
</style>
